import React, { Fragment } from 'react'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// icons
import { faBars, faEdit, faPercent } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { withRouter } from 'react-router'

// services

import Select from 'react-select'
import Header from '../Header/Header'
import useEdit from './hooks/useEdit'

function EditFamilia({ history, location }) {
    const { formikEdit, departamentos } = useEdit(history, location)
    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faBars} title={'Familias'} />
                </div>

                <div className="bg-gris p-4">
                    <form onSubmit={formikEdit.handleSubmit}>
                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label htmlFor="inputNombre">Nombre</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faBars} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputNombre"
                                        name="nombre"
                                        className="form-control"
                                        placeholder="Ej. Lacteos, Gaseosas..."
                                        value={formikEdit.values.nombre}
                                        onChange={formikEdit.handleChange}
                                        onBlur={formikEdit.handleBlur}
                                    />
                                </div>
                                {formikEdit.touched.nombre &&
                                    formikEdit.errors.nombre ? (
                                    <small className="form-text text-danger">
                                        {formikEdit.errors.nombre}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputNombre">Ganancia</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faPercent} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputGanancia"
                                        name="ganancia"
                                        className="form-control"
                                        placeholder="10"
                                        value={formikEdit.values.ganancia}
                                        onChange={formikEdit.handleChange}
                                        onBlur={formikEdit.handleBlur}
                                    />
                                </div>
                                {formikEdit.touched.ganancia &&
                                    formikEdit.errors.ganancia ? (
                                    <small className="form-text text-danger">
                                        {formikEdit.errors.ganancia}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputDepartamento">
                                    Departamento
                                </label>
                                <div>
                                    <Select
                                        placeholder={
                                            'Seleccionar un departamento'
                                        }
                                        options={departamentos}
                                        defaultValue={
                                            formikEdit.values.departamento
                                        }
                                        onChange={(value) =>
                                            formikEdit.setFieldValue(
                                                'departamento',
                                                value
                                            )
                                        }
                                        getOptionValue={(values) =>
                                            values.idDepartamento
                                        }
                                        getOptionLabel={(values) =>
                                            values.nombre
                                        }
                                    ></Select>
                                </div>
                                {formikEdit.touched.departamento &&
                                    formikEdit.errors.departamento ? (
                                    <small className="form-text text-danger">
                                        {formikEdit.errors.departamento}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-outline-danger"
                            >
                                <FontAwesomeIcon icon={faEdit} /> Editar Familia{' '}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}
export default withRouter(EditFamilia)
